import { Box, Flex, Grid, Spacer, Text } from '@chakra-ui/react';
import { InMobile, useIsDesktop } from '@ui/components/MobileOrDesktop';
import { Swiper, SwiperSlide } from '@ui/components/Swiper';
import { useStakedNfts } from '@ui/hooks/useCruisers';
import { useTranslations } from '@ui/i18n';
import { InColorTheme } from '@veno-app/chakra';
import { Minus, Plus } from '@veno-app/icons';
import React from 'react';

import EmployHelperCard from '../EmployHelperCard';
import GardenHelperBoostCard from '../GardenBoostCard/GardenHelperBoostCard';
import StakeCruiserCard from './GardenNftDrawersShared/StakeCruiserCard';
import { useGardenNftDrawerStore } from './GardenNftDrawersShared/useGardenNftDrawer';
import GardenStakeNftDrawer from './GardenStakeNftDrawer';
import GardenUnstakeNftDrawer from './GardenUnstakeNftDrawer';
import { useGrowHelpers } from './GrowHelpersProvider';

function GardenHelpersMainContent() {
  const t = useTranslations();
  const { gardenType } = useGrowHelpers();
  // hook does nothing if feature not enabled
  const { data: stakedCruisers } = useStakedNfts(gardenType);
  const onOpenNftDrawer = useGardenNftDrawerStore((s) => s.onOpen);
  const isDesktop = useIsDesktop();

  return (
    <>
      <InColorTheme colorTheme="default">
        <GardenStakeNftDrawer />
        <GardenUnstakeNftDrawer />
      </InColorTheme>
      <GardenHelperBoostCard />
      <Box
        mt="24px"
        textStyle={{
          base: 'bodySmall',
          desktop: 'h4',
        }}
        textAlign="center"
      >
        {t('Hire up to 5 helpers to {br} grow your garden', {
          br: () => (
            <InMobile>
              <br />
            </InMobile>
          ),
        })}
      </Box>
      <Spacer mt={6} />
      <Flex gap={6} flexDir="column">
        <Grid
          mb={0}
          mx="auto"
          w="min-content"
          flex={0}
          gap={3}
          justifyItems="center"
          templateColumns="repeat(2, 1fr)"
        >
          <EmployHelperCard
            title={t('Hire')}
            icon={Plus}
            disabled={stakedCruisers?.length === 5}
            onClick={() => onOpenNftDrawer()}
          />
          <EmployHelperCard
            icon={Minus}
            title={t('Fire')}
            disabled={!stakedCruisers?.length}
            onClick={() => {
              onOpenNftDrawer('UNSTAKE');
            }}
          />
        </Grid>
        <Text
          hidden={!stakedCruisers?.length}
          textStyle={{
            base: 'bodySmall',
            desktop: 'h4',
          }}
          textAlign={{
            base: 'center',
            desktop: 'left',
          }}
        >
          {t('Helper Info')}
        </Text>
      </Flex>
      {!!stakedCruisers?.length && (
        <>
          <Box mt={4} zIndex={0}>
            <Swiper slidesPerView={isDesktop ? 5 : 3.5} spaceBetween={0}>
              {stakedCruisers.map((cruiser, i) => (
                <SwiperSlide key={i}>
                  <StakeCruiserCard
                    w="98px"
                    p={0}
                    active={false}
                    shadow="undefined"
                    checkable={false}
                    {...cruiser}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </Box>
        </>
      )}
    </>
  );
}

export default GardenHelpersMainContent;
